import { getRouteApi } from '@tanstack/react-router';

export type UseClientOpts = object;

const authRoute = getRouteApi('/_auth');

// eslint-disable-next-line no-empty-pattern
export const useClient = ({}: UseClientOpts = {}) => {
  const { client } = authRoute.useLoaderData();
  return { client: client };
};
